(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global['@lagou/kw-lgsa'] = {}));
}(this, (function (exports) { 'use strict';

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var w = typeof window != 'undefined' ? window : {};
  (function (factory) {
      var OldCookies = w.Cookies;
      var api = w.Cookies = factory();
      api.noConflict = function () {
          w.Cookies = OldCookies;
          return api;
      };
  })(function () {
      function extend() {
          var i = 0;var result = {};for (; i < arguments.length; i++) {
              var attributes = arguments[i];for (var key in attributes) {
                  result[key] = attributes[key];
              }
          }return result;
      }function init(converter) {
          function api(key, value, attributes) {
              if (typeof document === "undefined") {
                  return;
              }if (arguments.length > 1) {
                  attributes = extend({ path: "/" }, api.defaults, attributes);if (typeof attributes.expires === "number") {
                      attributes.expires = new Date(new Date() * 1 + attributes.expires * 86400000);
                  }attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";try {
                      var result = JSON.stringify(value);if (/^[\{\[]/.test(result)) {
                          value = result;
                      }
                  } catch (e) {}value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);var stringifiedAttributes = "";for (var attributeName in attributes) {
                      if (!attributes[attributeName]) {
                          continue;
                      }stringifiedAttributes += "; " + attributeName;if (attributes[attributeName] === true) {
                          continue;
                      }stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
                  }return document.cookie = key + "=" + value + stringifiedAttributes;
              }var jar = {};var decode = function decode(s) {
                  return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
              };var cookies = document.cookie ? document.cookie.split("; ") : [];var i = 0;for (; i < cookies.length; i++) {
                  var parts = cookies[i].split("=");var cookie = parts.slice(1).join("=");if (!this.json && cookie.charAt(0) === '"') {
                      cookie = cookie.slice(1, -1);
                  }try {
                      var name = decode(parts[0]);cookie = (converter.read || converter)(cookie, name) || decode(cookie);if (this.json) {
                          try {
                              cookie = JSON.parse(cookie);
                          } catch (e) {}
                      }jar[name] = cookie;if (key === name) {
                          break;
                      }
                  } catch (e) {}
              }return key ? jar[key] : jar;
          }api.set = api;api.get = function (key) {
              return api.call(api, key);
          };api.getJSON = function () {
              return api.apply({ json: true }, arguments);
          };api.remove = function (key, attributes) {
              api(key, "", extend(attributes, { expires: -1 }));
          };api.defaults = {};api.withConverter = init;return api;
      }return init(function () {});
  });

  /**
   * 发送请求
   * content-type: application/json
   */
  function senData(_ref) {
      var url = _ref.url,
          _ref$method = _ref.method,
          method = _ref$method === undefined ? 'GET' : _ref$method,
          data = _ref.data;

      var xmlhttp = null;
      if (window.XMLHttpRequest) {
          // code for all new browsers
          xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
          // code for IE5 and IE6
          xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      if (xmlhttp != null) {
          xmlhttp.onreadystatechange = function () {
              if (xmlhttp && xmlhttp.readyState == 4) {
                  // 4 = "loaded"
                  if (xmlhttp.status == 200) ; else {
                      console.log("Problem retrieving XML data");
                  }
              }
          };
          xmlhttp.open(method || "GET", url, true);

          xmlhttp.setRequestHeader("Content-Type", "application/json");
          xmlhttp.send(method.toLowerCase() == 'post' && JSON.stringify(data) || null);
      } else {
          alert("Your browser does not support XMLHTTP.");
      }
  }

  /**
   * 神策数据生成uuid的规则
   * https://github.com/sensorsdata/sa-sdk-javascript/edit/master/product/sensorsdata.full.js
   */
  var UUID = function () {
      var T = function T() {
          var d = 1 * new Date(),
              i = 0;
          while (d == 1 * new Date()) {
              i++;
          }
          return d.toString(16) + i.toString(16);
      };
      var R = function R() {
          return Math.random().toString(16).replace('.', '');
      };
      var UA = function UA(n) {
          var ua = navigator.userAgent,
              i,
              ch,
              buffer = [],
              ret = 0;

          function xor(result, byte_array) {
              var j,
                  tmp = 0;
              for (j = 0; j < byte_array.length; j++) {
                  tmp |= buffer[j] << j * 8;
              }
              return result ^ tmp;
          }

          for (i = 0; i < ua.length; i++) {
              ch = ua.charCodeAt(i);
              buffer.unshift(ch & 0xFF);
              if (buffer.length >= 4) {
                  ret = xor(ret, buffer);
                  buffer = [];
              }
          }

          if (buffer.length > 0) {
              ret = xor(ret, buffer);
          }

          return ret.toString(16);
      };

      return function () {
          var se = String(screen.height * screen.width);
          if (se && /\d{5,}/.test(se)) {
              se = se.toString(16);
          } else {
              se = String(Math.random() * 31242).replace('.', '').slice(0, 8);
          }
          var val = T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
          if (val) {
              return val;
          } else {
              return (String(Math.random()) + String(Math.random()) + String(Math.random())).slice(2, 15);
          }
      };
  }();
  // 上报数据源
  var REMOTE = {
      server: document.location.protocol + '//sa.lagou.com/collect.gif'
  };

  /**
   * 获取当前日期和时间的字符串yyyyMMddHHmmss
   *
   * @returns
   */
  function getNowDatetimeStr() {
      var t = new Date();
      var dateArr = t.toLocaleString().split(' ')[0].split('/');
      var timeArr = t.toTimeString().split(' ')[0].split(':');
      var result = [].concat(dateArr, timeArr).map(function (item) {
          return add0(item);
      }).join('');
      return result;
  }
  function add0(num) {
      var _num = Number(num);
      if (isNaN(_num)) return num;
      return _num > 9 ? '' + _num : '0' + _num;
  }
  if (typeof w.Cookies != 'undefined' && !w.Cookies.get('WEBTJ-ID')) {
      w.Cookies.set('WEBTJ-ID', getNowDatetimeStr() + '-' + UUID(), {
          path: '/'
      });
  }

  var SA_SERVER = 'https://sa.lagou.com/collect.gif';
  var OUTER_KEY = {
      address_id: 1,
      content_id: 1,
      show_id: 1
  };
  var defualt_url = 'https://shenceyun.lagou.com/sa?project=production';
  var edu_url = 'https://shenceyun.lagou.com/sa?project=edudata';
  var test_edu_url = 'https://shenceyun.lagou.com/sa?project=default';
  var hasLogin = false;

  var app_type = 'lagou_edu';
  var platform_type = '';
  var eventEnum = {
      WebButtonClick: 'WebButtonClick',
      WebView: 'WebView',
      pcpv: 'pcpv',
      pcclick: 'pcpv',
      pcshow: 'pcshow'
      // 埋点配置对象
  };var saConfig = {
      LG_LOGIN_USER_ID: true
  };

  var LgSa = function () {
      function LgSa() {
          classCallCheck(this, LgSa);

          this.fullVersion = '';
          this._lgSaRegister = {};
          this._lgUserSimpleInfo = {};
          this.OSName = 'Unknown OS';
          this.browserName = '';
          this.init();
      }

      createClass(LgSa, [{
          key: "init",
          value: function init(config) {
              if (config) {
                  _extends(saConfig, config);
              }
              this.initPlatForm();
              this.initUserInfoAndPlatInfo();
              this.initScript();
              this.saRegister();
              this.notVelocityAndIsKw() && this.getUserInfo();
          }
      }, {
          key: "lgSaRegister",
          value: function lgSaRegister(data) {
              _extends(this._lgSaRegister, data || {});
          }
      }, {
          key: "initPlatForm",
          value: function initPlatForm() {
              var userAgent = navigator.userAgent;
              var reg = new RegExp(/lagou\/\S*/gi);
              var eduReg = new RegExp(/lgedu\/\S*/gi);
              var isPc = !/Android|webOS|iPhone|iPod|BlackBerry/i.test(userAgent);
              var isLgApp = reg.test(userAgent);
              var isEduApp = eduReg.test(userAgent);
              var isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios
              var isAPP = isLgApp || isEduApp;
              var isWx = userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
              if (isPc) {
                  platform_type = 'PC';
              } else if (!isAPP) {
                  platform_type = isWx ? 'H5' : 'M站';
              } else {
                  app_type = isEduApp ? 'lagou_edu' : 'lagou_emp';
                  platform_type = isIOS ? 'iOS' : 'Android';
              }
          }
      }, {
          key: "saRegister",
          value: function saRegister() {
              sa.clearAllRegister();

              sa.register({
                  $os: this.OSName,
                  $browser: this.browserName,
                  $browser_version: this.fullVersion
              });

              //登录后需要注册进入神策
              if (this._lgUserSimpleInfo.user_id) {
                  var _company = w.CONST_VARS('company') || {};
                  var _user = w.CONST_VARS('user') || {};
                  this._lgUserSimpleInfo.user_id && sa.login(this._lgUserSimpleInfo.user_id);
                  sa.register({
                      easy_company_id: this._lgUserSimpleInfo.easy_company_id,
                      lagou_company_id: this._lgUserSimpleInfo.lagou_company_id || ''
                  });
                  sa.setProfile({
                      LagouId: this._lgUserSimpleInfo.LGID || '',
                      CompanyId: this._lgUserSimpleInfo.easy_company_id,
                      CompanyShortName: _company.shortName,
                      CompanyName: _company.name,
                      phone: _user.phone,
                      last_login_time: new Date().getTime()
                  });
              }
          }
      }, {
          key: "initScript",
          value: function initScript() {
              if (document.querySelector('#initSaTrack')) {
                  return;
              }
              var initScript = document.createElement('script');
              initScript.id = "initSaTrack";
              initScript.text = " ;(function(para) {\n                var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script',x = null,y = null;\n                w['sensorsDataAnalytic201505'] = n;\n                w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};\n                var ifs = ['track','quick','register','registerPage','registerOnce','clearAllRegister','trackSignup', 'trackAbtest', 'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify','login','logout','trackLink','clearAllRegister','getAppStatus'];\n                for (var i = 0; i < ifs.length; i++) {\n                    w[n][ifs[i]] = w[n].call(null, ifs[i]);\n                }\n                if (!w[n]._t) {\n                    x = d.createElement(s), y = d.getElementsByTagName(s)[0];\n                    x.async = 1;\n                    x.src = p;\n                    x.charset = 'UTF-8';\n                    y.parentNode.insertBefore(x, y);\n                    w[n].para = para;\n                }\n            })({\n                sdk_url: 'https://s21.lgstatic.com/growth/activity/20210412/1618219685870.js',\n                name: 'sa',\n                cross_subdomain: true,\n                server_url: 'https://shenceyun.lagou.com/sa?project=";
              if (this.isKW()) {
                  var loginStatus = window.userInfo && window.userInfo.id || window.isLogin;
                  var commonObj = {
                      platform_type: platform_type,
                      app_type: app_type,
                      login_status: loginStatus ? 1 : 0
                  };
                  initScript.text += "edudata',\n                heatmap: {\n                    //default \u8868\u793A\u5F00\u542F\uFF0C\u81EA\u52A8\u91C7\u96C6 $WebClick \u4E8B\u4EF6\uFF0C\u53EF\u4EE5\u8BBE\u7F6E 'not_collect' \u8868\u793A\u5173\u95ED\u3002\n                    clickmap:'default',\n                    //default \u8868\u793A\u5F00\u542F\uFF0C\u81EA\u52A8\u91C7\u96C6 $WebStay \u4E8B\u4EF6\uFF0C\u53EF\u4EE5\u8BBE\u7F6E 'not_collect' \u8868\u793A\u5173\u95ED\u3002\n                    scroll_notice_map:'default'\n                }\n            });\n            sa.registerPage(" + JSON.stringify(commonObj) + ");\n            //\u8C03\u7528\u4EE3\u7801\u4E4B\u540E\uFF0CSDK \u5C31\u4F1A\u81EA\u52A8\u6536\u96C6\u9875\u9762\u6D4F\u89C8\u4E8B\u4EF6\uFF0C\u4EE5\u53CA\u8BBE\u7F6E\u521D\u59CB\u6765\u6E90\u3002\n            sa.quick('autoTrack');\n            ";
              } else {
                  initScript.text += "production'});";
              }
              document.head.appendChild(initScript);
          }
      }, {
          key: "initUserInfoAndPlatInfo",
          value: function initUserInfoAndPlatInfo() {
              var _navigator = navigator || {};
              var userAgent = _navigator.userAgent;
              var appVersion = _navigator.appVersion;
              this.browserName = _navigator.appName;
              this.fullVersion = String(parseFloat(appVersion));
              var verOffset = void 0;
              var ix = void 0;
              var nameOffset = void 0;

              // 浏览器名称
              if ((verOffset = userAgent.indexOf('Opera')) !== -1) {
                  this.browserName = 'Opera';
                  this.fullVersion = userAgent.substring(verOffset + 6);
                  if ((verOffset = userAgent.indexOf('Version')) !== -1) this.fullVersion = userAgent.substring(verOffset + 8);
              } else if ((verOffset = userAgent.indexOf('MSIE')) !== -1) {
                  this.browserName = 'Microsoft Internet Explorer';
                  this.fullVersion = userAgent.substring(verOffset + 5);
              } else if ((verOffset = userAgent.indexOf('Chrome')) !== -1) {
                  this.browserName = 'Chrome';
                  this.fullVersion = userAgent.substring(verOffset + 7);
              } else if ((verOffset = userAgent.indexOf('Safari')) !== -1) {
                  this.browserName = 'Safari';
                  this.fullVersion = userAgent.substring(verOffset + 7);
                  if ((verOffset = userAgent.indexOf('Version')) !== -1) this.fullVersion = userAgent.substring(verOffset + 8);
              } else if ((verOffset = userAgent.indexOf('Firefox')) !== -1) {
                  this.browserName = 'Firefox';
                  this.fullVersion = userAgent.substring(verOffset + 8);
              } else if ((nameOffset = userAgent.lastIndexOf(' ') + 1) < (verOffset = userAgent.lastIndexOf('/'))) {
                  this.browserName = userAgent.substring(nameOffset, verOffset);
                  this.fullVersion = userAgent.substring(verOffset + 1);
                  if (this.browserName.toLowerCase() === this.browserName.toUpperCase()) {
                      this.browserName = _navigator.appName;
                  }
              }

              // 系统名称
              if (userAgent.indexOf('Win') !== -1) {
                  this.OSName = 'Windows';
              } else if (userAgent.indexOf('Mac') !== -1) {
                  this.OSName = 'MacOS';
              } else if (appVersion.indexOf('X11') !== -1) {
                  this.OSName = 'UNIX';
              } else if (userAgent.indexOf('Linux') !== -1) {
                  this.OSName = 'Linux';
              } else if (userAgent.indexOf('Android') !== -1) {
                  this.OSName = 'Android';
              } else if (userAgent.indexOf('like Mac') !== -1) {
                  this.OSName = 'iOS';
              }

              //版本号
              if ((ix = this.fullVersion.indexOf(';')) !== -1) this.fullVersion = this.fullVersion.substring(0, ix);
              if ((ix = this.fullVersion.indexOf(' ')) !== -1) this.fullVersion = this.fullVersion.substring(0, ix);

              var majorVersion = parseInt(String(this.fullVersion), 10);
              if (isNaN(majorVersion)) {
                  this.fullVersion = String(parseFloat(appVersion));
                  majorVersion = parseInt(appVersion, 10);
              }

              // 用户基本信息
              if (window.CONST_VARS) {
                  var _company = window.CONST_VARS('company') || {};
                  var _user = window.CONST_VARS('user') || {};
                  this._lgUserSimpleInfo.LGID = _user.id;
                  this._lgUserSimpleInfo.user_id = _user.id;
                  this._lgUserSimpleInfo.easy_company_id = _company.id;
                  this._lgUserSimpleInfo.lagou_company_id = _company.lgId;
              }
              if (window.userInfo && window.userInfo.user_id) {
                  this._lgUserSimpleInfo.user_id = window.userInfo.user_id;
              }
          }

          /**
           * user_id 用户id
           * LGID C端用户id
           * easy_company_id 简招公司id
           * lagou_company_id 拉勾公司id
           * @param userInfo
           */

      }, {
          key: "registerUserInfo",
          value: function registerUserInfo(userInfo) {
              this._lgUserSimpleInfo = _extends({}, this._lgUserSimpleInfo, userInfo);
          }
      }, {
          key: "isKW",
          value: function isKW() {
              return window.location.host === 'kaiwu.lagou.com' || window.location.host === 'edu.lagou.com';
          }
      }, {
          key: "defaultBrowserParam",
          value: function defaultBrowserParam() {
              return {
                  lt: 'pcclick',
                  os: this.OSName,
                  browser: this.browserName,
                  browser_version: this.fullVersion,
                  screen_height: window.screen.height,
                  screen_width: window.screen.width,
                  referer: document.referrer,
                  url: location.href
              };
          }
      }, {
          key: "defaultUserInfo",
          value: function defaultUserInfo() {
              var basicTrack = {
                  time: new Date().getTime(),
                  LGID: window.Cookies.get('WEBTJ-ID')
                  // 是否使用长的user_id，通常埋点平台只识别短的user_id
              };if (saConfig.LG_LOGIN_USER_ID) {
                  basicTrack.user_id = window.Cookies.get('LG_LOGIN_USER_ID');
              }
              return _extends(this._lgUserSimpleInfo, basicTrack);
          }
          // 替换url后缀为.gif

      }, {
          key: "replaceUrl",
          value: function replaceUrl(str) {
              return str.replace(/\/sa$/, '/sa.gif').replace(/(\/sa)(\?[^\/]+)$/, '/sa.gif$2');
          }
      }, {
          key: "is_new_event",
          value: function is_new_event(event) {
              return eventEnum[event];
          }
      }, {
          key: "saTrack",
          value: function saTrack(event, actions, url) {
              var _this = this;

              return new Promise(function (resolve) {
                  var server_url = url || defualt_url;
                  var is_old_url = server_url.split("=")[1] == 'production';
                  if (is_old_url && _this.is_new_event(event)) {
                      event = actions.page_id;
                  }
                  var curPara = { server_url: _this.replaceUrl(server_url) };
                  if (window.sa) {
                      window.sa.para = _extends(window.sa.para, curPara);
                      if (actions.address_id) {
                          actions.aId = actions.address_id;
                          delete actions.address_id;
                      }
                      if (actions.content_id) {
                          actions.content = actions.content_id;
                          delete actions.content_id;
                      }

                      //神策不支持数字开头 做一个补充 统一加下 "_"
                      if (/^\d/.test(event)) {
                          event = '_' + event;
                      }
                      window.sa.track(event, actions, function () {
                          resolve();
                      });
                  }
              });
          }

          //平台上报

      }, {
          key: "track",
          value: function track(event, actions) {
              var is_new_event = this.is_new_event(event);
              if (actions instanceof Object) {
                  //处理所有手动传递过来的参数
                  var page_id = is_new_event ? actions.page_id : event;
                  var allLogData = {
                      page_id: page_id || '',
                      click_props: {}
                  };

                  for (var actionKey in actions) {
                      if (actions.hasOwnProperty(actionKey)) {
                          if (OUTER_KEY[actionKey]) {
                              allLogData[actionKey] = actions[actionKey];
                          } else {
                              allLogData.click_props[actionKey] = String(actions[actionKey]);
                          }
                      }
                  }

                  allLogData = _extends(allLogData, this.defaultBrowserParam(), this.defaultUserInfo(), this._lgSaRegister);
                  // let uploadLogImg=new Image();
                  senData({
                      url: SA_SERVER, method: 'post', data: {
                          plat: platform_type == 'M站' ? 'H5' : platform_type,
                          data: JSON.stringify(allLogData)
                      }
                  });
                  // uploadLogImg.src=`${SA_SERVER}?plat=${platform_type == 'M站' ? 'H5': platform_type}&data=${encodeURIComponent(JSON.stringify(allLogData))}`;
              } else {
                  console.warn('error type: not standard object!');
              }
          }

          //神策上报和平台上报两种

      }, {
          key: "twoPlatTrack",
          value: function twoPlatTrack(event) {
              var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              this.track(event, actions);
              this.saTrack(event, actions);
          }
      }, {
          key: "ajax",
          value: function ajax(method, url, callback, data) {
              var xhr = new XMLHttpRequest() || new ActiveXObject('Microsoft.XMLHTTP');
              xhr.open(method, url, true);
              xhr.withCredentials = true;
              xhr.setRequestHeader("X-L-REQ-HEADER", "{deviceType:1}");
              if (method === 'get') {
                  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                  xhr.send();
              }
              if (method === 'post') {
                  xhr.setRequestHeader('Content-Type', 'application/json');
                  xhr.send(JSON.stringify(data));
              }
              xhr.onreadystatechange = function () {
                  if (this.readyState === 4 && this.status === 200) {
                      callback(JSON.parse(this.responseText));
                  }
              };
          }
          // kw拆分新的项目完全前后端分离，新的项目不再使用velocity变量，通过接口判断loginstatus

      }, {
          key: "getUserInfo",
          value: function getUserInfo() {
              this.ajax('get', 'https://gate.lagou.com/v1/neirong/edu/member/getSampleUserInfo', function (res) {
                  if (res && res.state === 1) {
                      hasLogin = true;
                  } else {
                      hasLogin = false;
                  }
              });
          }
          //教育下新项目没有velocity

      }, {
          key: "notVelocityAndIsKw",
          value: function notVelocityAndIsKw() {
              return !window.userInfo && this.isKW();
          }
      }, {
          key: "hasUserInfo",
          value: function hasUserInfo() {
              return window.userInfo && window.userInfo.id || window.isLogin;
          }
          // 教育上报

      }, {
          key: "eduPlatTrack",
          value: function eduPlatTrack(event) {
              var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var test = arguments[2];

              var url = test ? test_edu_url : edu_url;
              var loginStatus = this.hasUserInfo() || hasLogin;
              var commonObj = {
                  platform_type: platform_type,
                  app_type: app_type,
                  login_status: loginStatus ? 1 : 0
              };
              actions = _extends(commonObj, actions);
              this.track(event, actions);
              this.saTrack(event, actions, url);
          }
          //支持平台多类型上报

      }, {
          key: "platTrack",
          value: function platTrack(event, actions) {
              if (actions instanceof Object) {
                  //处理所有手动传递过来的参数
                  var page_id = actions.page_id;
                  var allLogData = {
                      page_id: page_id || '',
                      click_props: {}
                  };

                  for (var actionKey in actions) {
                      if (actions.hasOwnProperty(actionKey)) {
                          if (OUTER_KEY[actionKey]) {
                              allLogData[actionKey] = actions[actionKey];
                          } else {
                              allLogData.click_props[actionKey] = String(actions[actionKey]);
                          }
                      }
                  }

                  allLogData = _extends(allLogData, this.defaultBrowserParam(), this.defaultUserInfo(), this._lgSaRegister);
                  delete allLogData.click_props.lt;
                  allLogData.lt = event || this.defaultBrowserParam().lt;
                  if (allLogData.lt.indexOf('pv') !== -1) {
                      allLogData.browse_props = allLogData.click_props;
                      delete allLogData.click_props;
                  } else if (allLogData.lt.indexOf('show') !== -1) {
                      allLogData.show_props = allLogData.click_props;
                      delete allLogData.click_props;
                  }
                  console.log(allLogData);
                  // let uploadLogImg=new Image();
                  if (platform_type === 'iOS' || platform_type === 'Android') {
                      platform_type = 'H5';
                  }
                  senData({
                      url: SA_SERVER, method: 'post', data: {
                          plat: platform_type == 'M站' ? 'H5' : platform_type,
                          data: JSON.stringify(allLogData)
                      }
                  });
                  // uploadLogImg.src=`${SA_SERVER}?plat=${platform_type == 'M站' ? 'H5': platform_type}&data=${encodeURIComponent(JSON.stringify(allLogData))}`;
              } else {
                  console.warn('error type: not standard object!');
              }
          }
      }]);
      return LgSa;
  }();
  var lgSa = new LgSa();

  window.lgSa = lgSa;

  exports.LgSa = LgSa;
  exports.lgSa = lgSa;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
